@if(!isLoginIdSearchFinished) {
  <div class="body-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else {
  @if(loading) {
    <loading-animation [loadingMessage]="loadingMessage"></loading-animation>
  }
  <div class="auth-flex-container">
    <div class="form-wrapper" *ngIf="!formIsSubmitted && isPassedInUrlValid">
      <div class="form-header-wrapper">
        <h2 class="form-header-text">Password reset.</h2>
        <div><strong>{{loginId}}</strong></div>
      </div>
      <mat-slide-toggle [checked]="showNewPasswordDetails" (change)="showHideNewPasswordDetails($event)">Show/Hide password details</mat-slide-toggle>
      @if(showNewPasswordDetails) {
        <mat-password-strength-info class="password-strength" [passwordComponent]="newPasswordComponent"></mat-password-strength-info>
      }
      <form (ngSubmit)="onSubmit(newPasswordComponent)">
        <div id="content--pass-reset-wrapper">
          <mat-slide-toggle style="padding-right: 10px;" (change)="onShowHideNewPassword($event)">Show password</mat-slide-toggle>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label><strong>Enter new password</strong></mat-label>
              <input matInput #newPassword
                     [errorStateMatcher]="matcher"
                     [type]="newPasswordType"
                     required
                     autocomplete="new-password"
                     [formControl]="newPasswordComponent.passwordFormControl">
              <mat-error *ngIf="!newPasswordComponent.passwordFormControl.hasError('includesEmail')">Password is not valid</mat-error>
              <mat-error *ngIf="newPasswordComponent.passwordFormControl.hasError('includesEmail')">Password cannot contain your email address</mat-error>
            </mat-form-field>
            <mat-password-strength #newPasswordComponent
                                   (onStrengthChanged)="onNewPasswordStrengthChanged()"
                                   [min]=10
                                   [enableSpecialCharRule]=false
                                   [password]="newPassword.value">
            </mat-password-strength>
          </div>
          <mat-slide-toggle style="padding-right: 10px;" (change)="onShowHideCnfPassword($event)">Show password</mat-slide-toggle>
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label><strong>Confirm new password</strong></mat-label>
            <input matInput #cnfPassword
                   [errorStateMatcher]="matcher"
                   [type]="cnfPasswordType"
                   required autocomplete="new-password"
                   [formControl]="cnfPasswordControl"
                   placeholder="Password">
            <mat-error *ngIf="isPasswordMatch">Password is not valid</mat-error>
            <mat-error *ngIf="!isPasswordMatch">Password does not match</mat-error>
          </mat-form-field>
          <div class="submit-button">
            <button mat-flat-button
                    color="primary"
                    [class.disabled]="loading"
                    [disabled]="cnfPasswordControl.invalid"
                    type="submit">Submit
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="form-wrapper" *ngIf="formIsSubmitted && errorMessageToDisplay">
      <div class="form-header-wrapper">
        <h2 class="form-header-text">{{errorMessageToDisplay}}</h2>
        <div>To request a new password reset link, <a routerLink="/forgotPassword">click here.</a></div>
        <div>If you have any questions, please contact Customer Care at 1-800-282-7648.</div>
      </div>
    </div>
  </div>
}

